// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2SGZv","icon":"style_icon__1am-u","badge":"style_badge__37SVD"};